import styled from "styled-components";

export const QaAgentsStatisticConteiner = styled.div`
  padding-left: 130px;
  padding-right: 50px;
  padding-top: 100px;
`;

export const QaAgentsStatisticContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
`;

export const QaAgentsStatisticCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 250px;
  text-align: center;
`;

export const QaAgentsStatisticName = styled.h2`
  font-size: 20px;
  margin-bottom: 10px;
`;

export const QaAgentsStatisticStat = styled.p`
  font-size: 16px;
  margin: 5px 0;
`;

export const QaAgentsStatisticStatNumber = styled.span`
  font-weight: bold;
  color: ${({ color }) => color || "#333"};
`;

export const TableRow = styled.tr`
  &:hover {
    background-color: #f1f1f1; /* Цвет фона при ховере */
    cursor: pointer; /* Изменение курсора при ховере */
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

export const Th = styled.th`
  background-color: #f4f4f4;
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
  cursor: pointer;
`;

export const Td = styled.td`
  padding: 10px;
  border: 1px solid #ddd;
`;

export const StatNumber = styled.span`
  font-weight: bold;
`;
